import React from 'react'
import { addDays } from 'date-fns'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css';

const DateSelector = ({ dateFormat, selectedDate, setSelectedDate }) => {
  return (
    <div className="appointment-scheduler-date-selector">
      <DatePicker
        inline
        selectsRange
        name="appointment-scheduler-datepicker"
        onChange={setSelectedDate}
        selected={selectedDate}
        dateFormat={dateFormat}
        minDate={new Date()}
        startDate={selectedDate}
        className="appointment-scheduler-date-selector"
      />
    </div>
  )
}

export default DateSelector
